import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import RRuleGenerator, {
  translations
} from '../../../../../externalDependecies/react-rrule-generator';
import { lomavisCreatorRootState } from '../../../../../pages/lomavisCreator';
import TimeField from 'react-simple-timefield';
import {
  addPublicationDelay,
  addRecurringStr,
  addTime,
  clearRecurrenceData
} from '../../../../../redux/slices/lomavisCreator/lomavisCreator';
import { useTranslate } from '@tolgee/react';
import { Tooltip } from 'bootstrap';
import { getLanguage } from '../../../../../locales/language';
import { RRule, RRuleSet, rrulestr } from 'rrule';
import { TimeSelect } from '../../sharedComponents';
import { updateRecurrenceTime } from '../../../utils/helpers';

const RecurringPosts = () => {
  const dispatch = useDispatch();
  const { t } = useTranslate();

  const [hour, setHour] = useState<number>(12);
  const [minute, setMinute] = useState<number>(15);
  const [reloadKey, setReloadKey] = useState(0);

  const time = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.schedulePlanningData.time
  );
  const recurrence_info = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.schedulePlanningData
  );

  const publicationDelay = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.schedulePlanningData.publication_delay_in_minutes
  );
  const recurrenceString = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.schedulePlanningData.recurrence_as_str
  );
  const recurrence_Info = useSelector(
    (state: lomavisCreatorRootState) =>
      state.lomavisCreator.schedulePlanningData
  );

  const allData = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator
  );

  const [timeInputView, setTimeInputView] = useState(false);

  const publicationTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t('publication_delay_tooltip')}
              </div>
            </div></div>'`;
  const titleTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t('publication_recurring_title_tooltip')}
              </div>
            </div></div>'`;

  useEffect(() => {
    const tooltipTrigger = document.querySelector('.tooltip-trigger');
    const titleTooltipTrigger = document.querySelector(
      '.title-tooltip-trigger'
    );
    tooltipTrigger &&
      new Tooltip(tooltipTrigger, {
        title: 'title',
        placement: 'auto',
        trigger: 'hover',
        container: 'body',
        template: publicationTooltip
      });
    titleTooltipTrigger &&
      new Tooltip(titleTooltipTrigger, {
        title: 'title',
        placement: 'auto',
        trigger: 'hover',
        container: 'body',
        template: titleTooltip
      });
  }, []);

  const handleTimeChange = (hour: number, minute: number) => {
    const value = `${hour}:${minute}`;
    dispatch(
      addTime({
        Time: value
      })
    );
  };

  useEffect(() => {
    const [inputHour, inputMinute] = time?.split(':').map(Number);
    setHour(inputHour);
    setMinute(inputMinute);
  }, [time]);
  useEffect(() => {
    console.log('recurrence', recurrenceString);
    if (!recurrenceString) {
      reloadRRuleGenerator();
    }
  }, [recurrenceString]);

  const reloadRRuleGenerator = () => {
    setReloadKey((prevKey) => prevKey + 1);
  };
  useEffect(() => {
    if (recurrenceString) {
      const updatedRecurrenceInfo = updateRecurrenceTime({
        time,
        recurrence_as_str: recurrenceString,
        timezone: timeZone
      });
      dispatch(
        addRecurringStr({
          recurrence: updatedRecurrenceInfo
        })
      );
    }
  }, [time]);

  const timeZone = useSelector(
    (state: lomavisCreatorRootState) => state.lomavisCreator.timeZone
  );

  return (
    <div className="w-100 px-3 d-flex flex-column gap-4">
      <div className="d-flex flex-column gap-3">
        <h3 className="d-flex gap-1 align-items-center">
          {t('lomavisCreator.recurring_planning_head')}{' '}
          <i
            style={{ cursor: 'pointer', fontSize: '18px' }}
            className="fa-duotone fa-circle-info title-tooltip-trigger "
            data-bs-toggle="tooltip"
          ></i>
        </h3>
      </div>

      <RRuleGenerator
        key={reloadKey} // Use the reloadKey to control re-rendering
        onChange={(rrule) => {
          if (time) {
            const updatedRecurrenceInfo = updateRecurrenceTime({
              time,
              recurrence_as_str: rrule,
              timezone: timeZone
            });

            dispatch(
              addRecurringStr({
                recurrence: updatedRecurrenceInfo
              })
            );
          } else {
            dispatch(
              addRecurringStr({
                recurrence: rrule
              })
            );
          }
        }}
        value={recurrenceString}
        config={{
          hideStart: false,
          repeat: ['Weekly', 'Monthly', 'Yearly'],
          weekly: 'on',
          daily: 'on',
          start: ['datetime'],
          end: ['On date'],
          weekStartsOnSunday: false,
          hideError: true
        }}
        translations={
          getLanguage() === 'de' ? translations.german : translations.english
        }
      />

      <div className="form-group d-flex flex-column px-3 gap-3">
        <div className="">
          <label className="">
            <strong>{t('lomavisCreator.time')}*</strong>
          </label>
        </div>

        <TimeSelect
          hour={hour}
          setHour={setHour}
          minute={minute}
          setMinute={setMinute}
          onTimeChange={handleTimeChange}
        />
      </div>

      <div className="form-group d-flex flex-column px-3 gap-3">
        <div className="">
          <label className="d-flex gap-1 align-items-center">
            <strong>{t('lomavisCreator.publication_delay')}*</strong>
            <i
              style={{ cursor: 'pointer' }}
              className="fa-duotone fa-circle-info tooltip-trigger"
              data-bs-toggle="tooltip"
            ></i>
          </label>
        </div>

        <input
          id="minuteInput"
          type="number"
          className="form-control rounded-start px-3"
          placeholder={'0'}
          autoComplete="off"
          aria-label="Publication time"
          aria-describedby="basic-addon3"
          value={publicationDelay}
          onChange={(event) => {
            dispatch(
              addPublicationDelay({
                Time: event.target.value
              })
            );
          }}
        />
      </div>

      <div className="d-flex w-100 justify-content-end text-muted p-3">
        <div
          style={{ cursor: 'pointer' }}
          onClick={(event) => {
            setTimeInputView(false);
            dispatch(clearRecurrenceData({}));
          }}
          className="px-2"
        >
          Clear
        </div>
      </div>
    </div>
  );
};

export default RecurringPosts;
